import { useQuery } from '@tanstack/react-query';
import { getAdherenceService } from '../../../domains/adherence';

const isResultOk = (res: any) => res?.result_code === '200' || res?.resultCode === 200;

export type AdherencePatientType = 'long' | 'short';

/**
 * 복약이행관리 환자 리스트 (장기/단기 type별).
 * 같은 hook을 type='long' / type='short' 두 번 호출하면 query key 분리 → 각자 캐시.
 */
export const useAdherencePatientList = (
  brn: string | null | undefined,
  type: AdherencePatientType = 'long'
) => {
  return useQuery({
    queryKey: ['adherence-patients', brn, type],
    enabled: !!brn,
    queryFn: async () => {
      const res = await getAdherenceService().getPatients(brn, { type });
      if (!isResultOk(res)) return { patients: [], total: 0 };
      return {
        patients: (res?.data?.patients ?? []) as Array<Record<string, any>>,
        total: (res?.data?.total ?? 0) as number,
      };
    },
  });
};
